<template>
  <div class="doc-type">
    <button
      class="doc-type__switch"
      @click.prevent="docTypeVisible = !docTypeVisible"
    >
      Waar moet een bestand aan voldoen?
      <b-icon
        v-if="docTypeVisible"
        icon="chevron-down"
      />
      <b-icon
        v-else
        icon="chevron-up"
      />
    </button>
    <p
      v-if="docTypeVisible"
      class="doc-type__text"
    >
      - Soort document: {{ consiseInputTypes }}. <br/>
      - De bestandsnaam moet minimaal 3 en maximaal 128 karakters lang zijn.
    </p>
  </div>
</template>

<script>
export default {
  name: 'AllowedFileTypes',
  props: {
    allowedTypes: {
      type: Array,
      required: true,
      default: function() {
        return ['image/jpg', 'image/jpeg', 'image/png']
      }
    }
  },
  data() {
    return {
      docTypeVisible: false
    }
  },
  computed: {
    consiseInputTypes() {
      return this.allowedTypes.map(type => {
        // 'image/jpg' => .jpg
        return `.${type.split('/').reverse()[0]}`
      }).join(', ')
    }
  }
}
</script>

<style lang="scss">

.doc-type {
  margin-bottom: 10px;
  
  .doc-type__switch {
    display: flex;
    align-items: center;
    background-color: transparent;
    font: inherit;
    border: none;
    cursor: pointer;
    font-size: 16px;
    line-height: 22px;
    fill: $primary-darkblue;
    color: $primary-darkblue;
    .b-icon {
      margin-left: 0.3rem;
    }

    &:focus, &:hover {
      outline: 3px solid $primary-black;
    }
  }
}
</style>